import React, { Component } from 'react';
import '../../assets/css/about.css';
import Banner from "../../widget/PageBanner";
import OurMission from "./OurMission";
import OurVision from "./OurVision";
import Accreditation from "./Accreditation";
import dividerRight from '../../assets/images/divider-right.png';
import dividerLeft from '../../assets/images/divider-left.png';

export default class AboutUs extends Component {
	
	componentDidMount = () =>{
		window.scrollTo(0, 0);
	}

	
  render() {
    return (
		<div className="about-us-wrapper">	
			<Banner pagename="About"/>

			<div className="mobile our-people-wrapper">
				<h1>Our People</h1>
				<div className="banner-text our-people-content">
					Great people make us the who we are. We respect our people and encourage their ideas and creativity. We are committed to
					maintaining our amazing and diverse team of passionate travel specialists, who challenge each other and demonstrate 
					a <span className="bold">'can do'</span> attitude.
				</div>
			</div>
			<div className="divider-wrapper-right margin-top-2 margin-bottom-2">
				<img src={dividerRight} className="divider-right" alt="Plane divider" />
			</div>
			<div className="section-content-wrapper">
				<OurMission/>
			</div>
			<div className="section-content-wrapper">
				<OurVision/>
			</div>
			<div className="divider-wrapper-left">
				<img src={dividerLeft} className="divider-left" alt="Plane divider" />
			</div>
			<div className="section-content-wrapper">
				<Accreditation/>
			</div>
		</div>

    );
  }
}
